import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

import NewArtworkPage from "../../pages/Dashboard/NewArtworkPage";

export default function NewArtworkModal() {
  const navigate = useNavigate();

  const close = useCallback(() => navigate(-1, { replace: true }), [navigate]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [close]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[999]">
      <button
        type="button"
        onClick={close}
        className="absolute inset-0 bg-black/55 backdrop-blur-[6px]"
        aria-label="Close upload"
      />

      <div className="relative h-full w-full flex items-center justify-center p-4 sm:p-6">
        <div
          role="dialog"
          aria-modal="true"
          className="
            relative w-full
            max-w-[1200px]
            h-[92vh]
            rounded-[32px]
            border border-white/12
            bg-[#070B16]
            shadow-[0_40px_170px_rgba(0,0,0,0.75)]
            overflow-hidden
          "
        >
          <button
            type="button"
            onClick={close}
            className="
              absolute right-4 top-4 z-10
              h-10 w-10 rounded-full
              border border-white/12 bg-white/[0.04]
              hover:bg-white/[0.08]
              transition grid place-items-center
              text-white/85
            "
            aria-label="Close"
            title="Close"
          >
            <X size={18} />
          </button>

          <div className="h-full overflow-y-auto">
            <NewArtworkPage embedded onCancel={close} />
          </div>
        </div>
      </div>
    </div>
  );
}
